import { useEffect, useState } from 'react'
import useIsMounted from './useIsMounted'
import { GetReviews } from '../shared/helpers'

const useReviews = (productId) => {
  const isMounted = useIsMounted()
  const [reviews, setReviews] = useState({
    avgRating: '',
    reviewCount: '',
    questionCount: '',
    answerCount: '',
  })

  useEffect(() => {
    if (productId) {
      GetReviews(productId).then((data) => {
        if (!isMounted()) return
        if (data) setReviews(data)
      })
    }
  }, [productId, isMounted])

  return reviews
}

export default useReviews
